import _ from 'lodash'
import request from '@/utils/request'
import { v2Host } from '@/config/host'

/**
 * http://localhost:8067/?doc=material_grab.md
 * @param {{page: number, page_size: number, platform: string, is_playable: number, network: string, category: string, time: array, search_field: string, keyword: string}} params
 * @return {Promise<any>}
 */
export function getGrabList(params) {
  if (_.isArray(params.time)) {
    /* eslint-disable camelcase */
    const [start_date, end_date] = params.time
    params.start_date = start_date
    params.end_date = end_date
    /* eslint-enable camelcase */
    params = _.omit(params, ['time'])
  }

  return request({
    url: `${v2Host}/material/grab/list`,
    method: 'get',
    params: params
  })
}

/**
 * http://localhost:8067/?doc=material_grab.md
 * @param {{}} data
 * @return {Promise<any>}
 */
export function getGrabOptions(params = null) {
  return request({
    url: `${v2Host}/material/grab/options`,
    method: 'get',
    params: params
  })
}
